import {
  CurrencyField,
  DateField,
  SelectField,
  TextField,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { Checkbox, FormControlLabel, Grid, Tooltip, Typography } from '@material-ui/core';
import { isValid } from 'date-fns';
import { Help } from '@material-ui/icons';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';

export const RequestPayoffForm = observer(() => {
  const { loanStore: { loanDetails } } = useStore();
  const { payoffRequestStore } = usePayoffRequestStore();
  const partialPayoffDisabled = loanDetails?.properties?.length < 2;

  useEffect(() => {
    if (partialPayoffDisabled) {
      payoffRequestStore.onFieldChange('payoffMethod', 'Full Payoff');
    }
  }, []);

  const manageDate = date => {
    const selectedDate = isValid(date) ? date : null;
    payoffRequestStore.onFieldChange('goodThroughDate', selectedDate);
  }

  const setMaxDate = () => {
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);
    return maxDate;
  };

  const isWeekend = (date: Date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DateField
          testId="goodThroughDate"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          standaloneLabel
          label="When is the expected loan payoff date?"
          value={payoffRequestStore.form.fields.goodThroughDate.value}
          onChange={date => manageDate(date)}
          fullWidth
          disablePast={true}
          maxDate={setMaxDate()}
          shouldDisableDate={isWeekend}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectField
          label='Select Payoff Type:'
          options={[
            {
              label: 'Full Payoff',
              value: 'Full Payoff',
            },
            {
              label: 'Partial Payoff',
              value: 'Partial Payoff',
            }
          ]}
          testId={'payoffMethod'}
          value={payoffRequestStore.form.fields.payoffMethod.value}
          onChange={value => payoffRequestStore.onFieldChange('payoffMethod', value)}
          fullWidth
          variant="outlined"
          standaloneLabel
          disabled={partialPayoffDisabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          standaloneLabel
          variant="outlined"
          label="Comments"
          value={payoffRequestStore.form.fields.comments.value}
          onChange={(e) => payoffRequestStore.onFieldChange('comments', e.target.value)}
          multiline
          rows={3}
          fullWidth
          testId='comments'
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={payoffRequestStore.form.fields.rush.value}
              onChange={(e) => payoffRequestStore.onFieldChange('rush', e.target.checked)}
              color="primary"
            />
          }
          label="Rush this payoff request"
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" color="textSecondary">This may take 2-3 business days. Extra fees will apply.</Typography>
      </Grid>
    </Grid>
  );
});